import { TableRow, TableCell } from '@mui/material'
import { DatasetStatus } from '@components'
import * as css from '@datasets/dataset-details/datasetHistoryV2/styled'
import { ITargetRow } from '@datasets/dataset-details/datasetHistoryV2/types'

interface ITargetTableRow extends ITargetRow {
  submissionStatus: DatasetStatus
  onClickOpenDrawer: (slug: string) => void
}

export const TargetTableRow = ({
  name,
  slug,
  onClickOpenDrawer,
  datasetPosts,
}: ITargetTableRow) => {
  const completedDestinations =
    datasetPosts.filter(d => d.status?.toLowerCase() === DatasetStatus.COMPLETE.toLowerCase())
      ?.length || 0
  return (
    <TableRow
      key={name}
      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      hover={true}
      onClick={() => {
        onClickOpenDrawer(slug)
      }}
    >
      <TableCell component="td" scope="row" sx={{ borderColor: '#C4C4C4' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <css.HeightLimitedImg
            src={`https://claravine-public-prod.s3-us-west-2.amazonaws.com/images/${slug}.png`}
            alt={name}
          />
          <div>{name}</div>
        </div>
      </TableCell>
      <TableCell align="center" sx={{ borderColor: '#C4C4C4' }}>
        {completedDestinations}
        {`/${datasetPosts?.length}`}
      </TableCell>
    </TableRow>
  )
}
